// extracted by mini-css-extract-plugin
module.exports = {"basketItemPromotionCountdown":"BasketItemPromotionCountdown_basketItemPromotionCountdown__b_YrM"};